import RootLayout from './components/layout/root_layout.jsx';

export default function App() {
    // Render
    return <RootLayout />;
}
